export class PerformancePeerGroupFirmModel {
  criteria: any[];
  practiceGroup: any[];
  offices: any[];
}
